import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const AdvancedFilterPanel = ({ 
  onFiltersChange, 
  currentFilters = {},
  isCollapsed = false,
  onToggleCollapse 
}) => {
  const [filters, setFilters] = useState({
    period: 'month',
    comparison: 'previous_period',
    segments: ['all'],
    template: 'executive_summary',
    ...currentFilters
  });

  const periodOptions = [
    { value: 'week', label: 'Esta Semana' },
    { value: 'month', label: 'Este Mês' },
    { value: 'quarter', label: 'Este Trimestre' },
    { value: 'year', label: 'Este Ano' },
    { value: 'custom', label: 'Período Personalizado' }
  ];

  const comparisonOptions = [
    { value: 'previous_period', label: 'Período Anterior' },
    { value: 'same_period_last_year', label: 'Mesmo Período Ano Passado' },
    { value: 'budget', label: 'vs. Orçamento' },
    { value: 'industry_average', label: 'vs. Média do Setor' }
  ];

  const segmentOptions = [
    { value: 'all', label: 'Todos os Segmentos' },
    { value: 'products', label: 'Produtos' },
    { value: 'services', label: 'Serviços' },
    { value: 'channels', label: 'Canais de Venda' },
    { value: 'customers', label: 'Segmentos de Cliente' }
  ];

  const templateOptions = [
    { value: 'executive_summary', label: 'Resumo Executivo' },
    { value: 'financial_performance', label: 'Performance Financeira' },
    { value: 'operational_efficiency', label: 'Eficiência Operacional' },
    { value: 'market_analysis', label: 'Análise de Mercado' },
    { value: 'custom', label: 'Relatório Personalizado' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFiltersChange?.(newFilters);
  };

  const resetFilters = () => {
    const defaultFilters = {
      period: 'month',
      comparison: 'previous_period',
      segments: ['all'],
      template: 'executive_summary'
    };
    setFilters(defaultFilters);
    onFiltersChange?.(defaultFilters);
  };

  if (isCollapsed) {
    return (
      <div className="bg-card border border-border rounded-lg p-4 mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Icon name="Filter" size={20} className="text-primary" />
            <span className="font-heading-semibold text-sm text-card-foreground">
              Filtros Ativos
            </span>
            <div className="flex items-center space-x-2">
              <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full font-body-medium">
                {periodOptions?.find(p => p?.value === filters?.period)?.label}
              </span>
              <span className="px-2 py-1 bg-accent/10 text-accent-foreground text-xs rounded-full font-body-medium">
                {templateOptions?.find(t => t?.value === filters?.template)?.label}
              </span>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            iconName="ChevronDown"
            onClick={onToggleCollapse}
          >
            Expandir
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6 card-shadow">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <Icon name="Filter" size={20} className="text-primary" />
          <h2 className="font-heading-semibold text-lg text-card-foreground">
            Filtros Avançados
          </h2>
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="RotateCcw"
            onClick={resetFilters}
          >
            Limpar
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="ChevronUp"
            onClick={onToggleCollapse}
          >
            Recolher
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Período de Análise"
          options={periodOptions}
          value={filters?.period}
          onChange={(value) => handleFilterChange('period', value)}
        />

        <Select
          label="Comparação"
          options={comparisonOptions}
          value={filters?.comparison}
          onChange={(value) => handleFilterChange('comparison', value)}
        />

        <Select
          label="Segmentos"
          options={segmentOptions}
          value={filters?.segments?.[0]}
          onChange={(value) => handleFilterChange('segments', [value])}
        />

        <Select
          label="Template de Relatório"
          options={templateOptions}
          value={filters?.template}
          onChange={(value) => handleFilterChange('template', value)}
        />
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4 text-sm text-muted-foreground">
            <span>Última atualização: 29/08/2025 10:05</span>
            <span>•</span>
            <span>Próxima atualização: 29/08/2025 22:00</span>
          </div>
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
          >
            Exportar Configuração
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdvancedFilterPanel;